import { Navigate } from 'react-router-dom';
import useGet from '../Hooks/useGet';
import API_ENDPOINTS from '../Config/api';

export default function AwarenessRoute({ children }) {
  const { fetchedData: orderData, loading } = useGet(API_ENDPOINTS.currentOrder);

  // Mostra loading mentre carica
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Se non ha Awareness abilitato, reindirizza al dashboard
  if (!orderData?.features?.awareness?.enabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}